/** SSOT for SAH quarter-budget provisioning copy (Slice C U-01/U-02). */
export const SAH_BUDGET_PROVISION_ACTION_LABEL = 'Provision the current-quarter budget';

export const SAH_BUDGET_PROVISION_TIMELINE_DETAIL = SAH_BUDGET_PROVISION_ACTION_LABEL;

export const SAH_BUDGET_PROVISION_QUEUE_TITLE = SAH_BUDGET_PROVISION_ACTION_LABEL;

export const SAH_BUDGET_PROVISION_QUEUE_DETAIL =
  'Set the current-quarter individualised budget from the care-plan workspace or budget tab before agreement and funded delivery.';
